import { getGeoRequest } from './api-requests';

const urlPath1 = 'https://maps.googleapis.com/maps/api/geocode/json?address=';
const urlPath2 = '&key=AIzaSyDsW0QYQKqkoFzkzykwKY3gyMWPehZnc2c';

export const Address = Object.freeze({
    coordinates: address => getGeoRequest(`${urlPath1}${address}${urlPath2}`)
});



// WEBPACK FOOTER //
// ./src/customModules/Common/rest-api/api-address-location.js